import { useMemo, useCallback } from 'react';
import useUser from '@/hooks/useUser';
import { useFlag } from '@/features/unleash';

export const useLearningContent = (contentKey: string) => {
  const featureFlag = useFlag({ name: 'learning-loop' });
  const isFeatureEnabled =
    featureFlag.flagsReady &&
    featureFlag.enabled &&
    featureFlag.variant.name === 'variant';

  const { data: user, mutate: mutateUser } = useUser();

  const isCardDismissed = useMemo(
    () =>
      !isFeatureEnabled ||
      user.learningContent?.dismissedCards?.includes(contentKey),
    [contentKey, isFeatureEnabled, user.learningContent?.dismissedCards]
  );

  const handleDismiss = useCallback(() => {
    if (user.learningContent?.dismissedCards) {
      mutateUser({
        settings: {
          learning_content: {
            dismissed_cards: [
              ...user.learningContent?.dismissedCards,
              contentKey,
            ],
          },
        },
      });
    }
  }, [contentKey, mutateUser, user.learningContent?.dismissedCards]);

  return { isCardDismissed, handleDismiss, contentKey };
};
